import React, { useContext, useEffect, useState } from 'react';

import { excApi, handleApiCall } from '@exchange-frontends/api';
import { useIsMounted } from '@exchange-frontends/custom-hooks';

import { useStore } from '../../../store';
import { UserDataContext } from '../../App';
import AcquireAppButton from './AcquireAppButton';
import { FastSpringForm } from './FastSpringForm';
import { HeaderButtonsContext } from './HeaderButtons';

const prepareCCContextualStoreFront = async (data, pricingInfo, profile, appType) => {
  await window.initializeFastSpring({ cloud: 'cc', appType });
  
  if (!window.fastspring?.builder) {
    console.error('FastSpring builder not available - cannot proceed with checkout');
    return;
  }

  window.fastspring.builder.tag({ referrer: data });
  window.fastspring.builder.push({
    products: [{ path: pricingInfo?.buyUrl, quantity: 1 }],
    paymentContact: {
      email: profile?.email,
      firstName: profile?.first_name,
      lastName: profile?.last_name,
    },
    checkout: true,
  });
};

const CcPaidAppButton = () => {
  const { accessToken, profile } = useContext(UserDataContext) ?? {};
  const { fetchCreativeCloudLink, setShowPluginAcquiredDialog } = useContext(HeaderButtonsContext);

  const isMounted = useIsMounted();
  const [fastSpringId, setFastSpringId] = useState('');
  const [isProcessingOrder, setIsProcessingOrder] = useState(false);
  const detailScreen = useStore((state) => state.detailScreen);
  const { id: appId, appVersionId: versionId, appType, pricingInfo } = detailScreen ?? {};

  const isContextualCheckout = pricingInfo?.buyUrl?.includes('-context');

  useEffect(() => {
    const handlePopupClosed = async (data) => {
      if (data && data.id) {
        useStore.setState({ acquired: true });
        await fetchCreativeCloudLink('install');
        setShowPluginAcquiredDialog(true);
      }
      if (isMounted.current) {
        setIsProcessingOrder(false);
      }
    };

    window.dataPopupClosed = handlePopupClosed;
    return () => {
      delete window.dataPopupClosed;
    };
  }, [
    isMounted,
    fetchCreativeCloudLink,
    setShowPluginAcquiredDialog,
  ]);

  const acquirePaidCCApp = async () => {
    try {
      const handler = handleApiCall(excApi.generateUniqueIdV2, {
        appId,
        versionId,
        appType,
        accessToken,
      });

      const response = await handler.run();

      if (isMounted.current && !response.error) {
        if (isContextualCheckout) {
          setIsProcessingOrder(true);
          await prepareCCContextualStoreFront(response, pricingInfo, profile, appType);
        } else {
          setFastSpringId(response);
        }
      } else {
        if (isMounted.current) {
          setIsProcessingOrder(false);
        }
      }
    } catch (error) {
      if (isMounted.current) {
        setIsProcessingOrder(false);
      }
    }
  };

  return (
    <>
      <AcquireAppButton 
        type="paid" 
        onPress={acquirePaidCCApp} 
        isLoading={isProcessingOrder} 
      />
      {!isContextualCheckout && profile && (
        <FastSpringForm 
          buyUrl={pricingInfo?.buyUrl} 
          fastSpringId={fastSpringId}
        />
      )}
    </>
  );
};

export default CcPaidAppButton;
